import type { Translations } from "../types";

const tr: Translations = {
  "meta.title": "Ülkelere Göre Tıklama Haritası",
  "meta.description":
    "Etkileşimli dünya haritası: ülke başına ücretsiz tıklamaların yanı sıra Stripe, PayPal ve Buy Me a Coffee ile ücretli destek.",

  "app.title": "Ülkelere Göre Tıklama Haritası",

  "map.intro":
    "Ücretsiz oy vermek için haritada bir ülkeye tıklayın veya finansal destek gönderin - her ikisi de aşağıdaki birleşik lider tablosuna dahil edilir. Harita yalnızca bu uygulama içindeki desteği yansıtır, gerçek ulusal serveti veya GSYİH'yi değil.",
  "map.verifying": "Doğrulanıyor …",
  "map.confirmNotRobot": "Ücretsiz tıklama ekleyebilmeden önce, robot olmadığınızı hızlıca onaylayın:",
  "map.tryAgain": "Tekrar dene",
  "map.registeringClick": "Tıklama kaydediliyor …",
  "map.selectedCountry": "Seçilen ülke: {name}.",
  "map.selectFirstFeedback": "Ülke seçildi. Ücretsiz tıklama eklemek için önce aşağıda robot olmadığınızı onaylayın.",
  "map.verificationExpired": "Doğrulamanın süresi doldu - robot olmadığınızı tekrar onaylayın.",
  "map.slowDown": "Biraz yavaşlayın - bir sonraki tıklamanızdan önce kısa bir süre bekleyin.",
  "map.clickFailed": "Tıklama kaydedilemedi. Lütfen tekrar deneyin.",
  "map.clickErrorGeneric": "Tıklama kaydedilirken hata oluştu.",
  "map.leaderboardHeading": "Ülke Lider Tablosu",
  "map.emptySelection": "Tıklamak veya desteklemek için haritada bir ülke seçin.",
  "map.loadingData": "Veriler yükleniyor …",

  "worldmap.loadError": "Harita yüklenemedi.",
  "worldmap.resetZoom": "Yakınlaştırmayı sıfırla",
  "worldmap.resetButton": "⤾ Sıfırla",
  "worldmap.loadingMap": "Harita yükleniyor …",
  "worldmap.unknownCountry": "Bilinmiyor",
  "worldmap.ariaClicks": "{name}: {clicks} tıklama",
  "worldmap.tooltipClicks": "{clicks} tıklama",

  "legend.fewer": "Daha az tıklama",
  "legend.more": "Daha fazla tıklama",

  "list.empty": "Henüz tıklama yok. İlk sen ol!",
  "list.ariaLabel": "Tıklamaya göre ülke lider tablosu",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY ayarlanmamış - yapılandırma için README dosyasına bakın.",
  "human.verificationFailedGeneric": "Doğrulama başarısız oldu.",
  "human.networkError":
    "Doğrulamaya ulaşılamadı (ağ hatası) - VITE_SUPABASE_URL'yi, verify-human'ın devreye alındığını ve ALLOWED_ORIGIN'i kontrol edin; README/NAVODILA dosyasına bakın.",
  "human.verificationFailedRetry": "Doğrulama başarısız oldu, tekrar deneyin.",

  "provider.stripe": "💳 Kart (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Seçilen ülke",
  "panel.currentlyRanked": "Şu anda #{rank} sırada",
  "panel.shareCopied": "Kopyalandı ✓",
  "panel.shareShared": "Paylaşıldı ✓",
  "panel.shareButton": "🔗 Paylaş",

  "panel.tableClicks": "Tıklama",
  "panel.tableFree": "Ücretsiz",
  "panel.tablePaid": "Ücretli",
  "panel.rowAllTime": "Tüm zamanlar",
  "panel.rowThisYear": "Bu yıl",
  "panel.rowThisWeek": "Bu hafta",
  "panel.rowToday": "Bugün",

  "panel.totalCombined": "Toplam:",
  "panel.totalSupport": "Toplam destek:",

  "panel.paymentMethod": "Ödeme yöntemi",
  "panel.noPaymentMethod": "Şu anda kullanılabilir bir ödeme yöntemi yok.",
  "panel.supportAmount": "Destek tutarı (EUR)",
  "panel.amountRange": "Tutar {min} ile {max} arasında olmalıdır.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Tahmini ücretli tıklama:",
  "panel.ratioInfo":
    "Oran: {a} = {b} tıklama (örn. {c} = {d} tıklama). Bu, ödeme öncesi yalnızca bir tahmindir - nihai tıklama sayısı her zaman sunucu tarafından, gerçekten onaylanan ödemeye göre hesaplanır ve onaylanır.",
  "panel.preparing": "Hazırlanıyor …",
  "panel.continueWith": "{provider} ile devam et",
  "panel.choosePaymentMethod": "Bir ödeme yöntemi seçin",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME ayarlanmamış - yapılandırma için README dosyasına bakın.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID ayarlanmamış - yapılandırma için README dosyasına bakın.",

  "panel.paypalAmountInfo": "Tutar: {amount} (tahmini {clicks} tıklama). Ödemeyi aşağıdaki PayPal düğmesiyle tamamlayın.",
  "panel.back": "← Geri",

  "panel.bmcWarningTitle": "⚠️ BuyMeCoffee'ye devam etmeden önce:",
  "panel.bmcWarningBody":
    "Ödeme sırasında aşağıdaki kodu mesaj/not alanına yapıştırın — hangi ülkeyi desteklediğinizi bilmemizin tek yolu bu. Kod olmadan ödemeyi herhangi bir ülkeyle ilişkilendiremeyiz.",
  "panel.copy": "Kopyala",
  "panel.copied": "Kopyalandı ✓",
  "panel.suggestedAmount": "Önerilen tutar:",
  "panel.bmcAmountNote":
    "(tahmini {clicks} tıklama). Maalesef BuyMeCoffee, tutarın bağlantı üzerinden aktarılmasını desteklemiyor — tutarı kendi sitelerinde kendiniz girin/seçin. Gerçek tıklama sayısı her zaman BuyMeCoffee'de gerçekten gönderdiğiniz tutardan hesaplanır, bu tahminden değil.",
  "panel.openBmc": "BuyMeCoffee'yi aç ve devam et →",
  "panel.waitingProvider": "Ödeme sağlayıcısından ödeme onayı bekleniyor …",
  "panel.waitingConfirmation": "Ödeme onayı bekleniyor …",
  "panel.timedOut":
    "Kontrol zaman aşımına uğradı. Ödemeyi tamamladıysanız, sunucu onayı aldığında harita güncellenecektir - bu bazen biraz daha uzun sürebilir.",
  "panel.checkAgain": "Tekrar kontrol et",

  "panel.cancelled": "Ödeme iptal edildi veya gerçekleşmedi. Harita değişmedi.",
  "panel.tryAgain": "Tekrar dene",

  "panel.confirmed": "✅ Destek onaylandı!",
  "panel.confirmedBody": "{country}, {amount} karşılığında {clicks} ücretli tıklama aldı.",

  "panel.errorPreparingSupport": "Desteğiniz hazırlanırken hata oluştu.",
  "panel.errorPreparingPayment": "Ödeme hazırlanırken hata oluştu.",
  "panel.errorConfirmingPayment": "Ödeme onaylanırken hata oluştu.",
  "panel.errorPayingPaypal": "PayPal ile ödeme yapılırken hata oluştu.",

  "share.unranked": "{flag}{country} dünya haritasında desteğine ihtiyaç duyuyor!\nLider tablosunda yükselmesine yardım et 👇",
  "share.rank1": "{flag}{country} şu anda #1 sırada!\nZirvede kalmamıza yardım et 👇",
  "share.rankN": "{flag}{country} şu anda #{rank} sırada!\n#1'e ulaşmamıza yardım et 👇",

  "language.switcherLabel": "Dil",
};

export default tr;
